import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'
import { CheckCircle,Calendar,Award } from 'lucide-react';
import custom_api_func2 from './axios_api_func_2';

const PublicCertificateView = () => {
  // In real implementation, fetch certificate data from API using publicid
  const [certificate, setCertificate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  var { publicid } = useParams()
  

  const Getallcertdetails = () => {
    custom_api_func2.get(`api/get_public_certifications/${publicid}`)
        .then((response) => {
            setCertificate(response.data.results)
            setLoading(false)
        }).catch((error) => {
          setLoading(false)
            //console.log("error", error);
        })
  }


  useEffect(() => {
    Getallcertdetails()
  }, [publicid]);


  

  if (loading) {
    return (
      <div style={styles.publicContainer}>
        <div style={styles.loadingSpinner}>
          <div style={styles.spinner}></div>
          <p>Verifying certificate...</p>
        </div>
      </div>
    );
  }

  if (error || !certificate) {
    return (
      <div style={styles.publicContainer}>
        <div style={styles.errorState}>
          <div style={styles.errorIcon}>❌</div>
          <h2 style={styles.errorTitle}>Certificate Not Found</h2>
          <p style={styles.errorDescription}>
            This certificate could not be verified. Please check the URL and try again.
          </p>
        </div>
      </div>
    );
  }

  if (!certificate.isValid) {
    return (
      <div style={styles.publicContainer}>
        <div style={styles.errorState}>
          <div style={styles.errorIcon}>⚠️</div>
          <h2 style={styles.errorTitle}>Invalid Certificate</h2>
          <p style={styles.errorDescription}>
            This certificate has been revoked or is no longer valid.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.publicContainer}>
      {/* Header */}
      <div style={styles.publicHeader}>
        <div style={styles.publicLogo}>
          <div style={styles.publicLogoIcon}>
            <img style={{height:"30px",width:"30px"}} src="/logo_sg_small.png" ></img>
          </div>
          <span style={styles.publicLogoText}>SuccessGuardian Academy</span>
        </div>
      </div>

      {/* Certificate Card */}
      <div style={styles.publicCertCard}>
        <div style={styles.publicCertBanner}>
          <div style={styles.publicBadge}>
            <Award size={60} color="#fff" />
          </div>
          <h1 style={styles.publicCertTitle}>Certificate of Completion</h1>
          <div style={styles.verifiedBadge}>
            <CheckCircle size={20} color="#4CAF50" />
            <span>Verified Certificate</span>
          </div>
        </div>

        <div style={styles.publicCertBody}>
          <div style={styles.publicRecipientSection}>
            <p style={styles.publicLabel}>This certifies that</p>
            <h2 style={styles.publicRecipientName}>{certificate.recipientName}</h2>
          </div>

          <div style={styles.publicCourseSection}>
            <p style={styles.publicLabel}>has successfully completed</p>
            <h3 style={styles.publicCourseName}>{certificate.courseName}</h3>
            
            <div style={styles.publicCourseDetails}>
              <div style={styles.publicDetailItem}>
                <span style={styles.publicDetailLabel}>Score</span>
                <span style={styles.publicDetailValue}>{certificate.score}%</span>
              </div>
              <div style={styles.publicDetailItem}>
                <span style={styles.publicDetailLabel}>Duration</span>
                <span style={styles.publicDetailValue}>{certificate.courseDetails.duration}</span>
              </div>
              <div style={styles.publicDetailItem}>
                <span style={styles.publicDetailLabel}>Lessons</span>
                <span style={styles.publicDetailValue}>{certificate.courseDetails.lessons}</span>
              </div>
            </div>
          </div>

          <div style={styles.publicMetaSection}>
            <div style={styles.publicMetaItem}>
              <Calendar size={18} color="#666" />
              <div>
                <p style={styles.publicMetaLabel}>Completion Date</p>
                <p style={styles.publicMetaValue}>{certificate.completionDate}</p>
              </div>
            </div>
            
            <div style={styles.publicMetaItem}>
              <Award size={18} color="#666" />
              <div>
                <p style={styles.publicMetaLabel}>Issued By</p>
                <p style={styles.publicMetaValue}>{certificate.issuedBy}</p>
              </div>
            </div>
          </div>

          <div style={styles.publicSignatureSection}>
            <div style={styles.publicSignature}>
              <p style={styles.publicSignatureName}>{certificate.issuerSignature}</p>
              <p style={styles.publicSignatureTitle}>{certificate.issuerTitle}</p>
            </div>
          </div>

          
        </div>
      </div>

      {/* Footer */}
      <div style={styles.publicFooter}>
        <p style={styles.publicFooterText}>
          This is an official certificate issued by SuccessGuardian Academy. 
        </p>
      </div>
    </div>
  );
};

const styles = {

  // Public Certificate View Styles
  publicContainer: {
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    padding: '40px 20px',
  },
  publicHeader: {
    maxWidth: '900px',
    margin: '0 auto 40px',
  },
  publicLogo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    justifyContent: 'center',
  },
  publicLogoIcon: {
    fontSize: '32px',
  },
  publicLogoText: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#333',
  },
  publicCertCard: {
    maxWidth: '900px',
    margin: '0 auto',
    backgroundColor: '#fff',
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
  },
  publicCertBanner: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: '60px 40px',
    textAlign: 'center',
    color: '#fff',
    position: 'relative',
  },
  publicBadge: {
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255,255,255,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 20px',
  },
  publicCertTitle: {
    fontSize: '36px',
    fontWeight: '700',
    marginBottom: '16px',
  },
  verifiedBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: 'rgba(255,255,255,0.9)',
    padding: '8px 16px',
    borderRadius: '24px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#4CAF50',
  },
  publicCertBody: {
    padding: '60px 40px',
  },
  publicRecipientSection: {
    textAlign: 'center',
    marginBottom: '40px',
    paddingBottom: '40px',
    borderBottom: '2px solid #f0f0f0',
  },
  publicLabel: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '12px',
    fontStyle: 'italic',
  },
  publicRecipientName: {
    fontSize: '40px',
    fontWeight: '700',
    color: '#333',
    marginBottom: '8px',
    fontFamily: 'Georgia, serif',
  },
  
  publicCourseSection: {
    textAlign: 'center',
    marginBottom: '40px',
    paddingBottom: '40px',
    borderBottom: '2px solid #f0f0f0',
  },
  publicCourseName: {
    fontSize: '28px',
    fontWeight: '600',
    color: '#5B21B6',
    marginBottom: '24px',
  },
  publicCourseDetails: {
    display: 'flex',
    justifyContent: 'center',
    gap: '40px',
    marginTop: '24px',
  },
  publicDetailItem: {
    textAlign: 'center',
  },
  publicDetailLabel: {
    fontSize: '12px',
    color: '#999',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    marginBottom: '4px',
    display: 'block',
  },
  publicDetailValue: {
    fontSize: '20px',
    fontWeight: '700',
    color: '#333',
    display: 'block',
  },
  publicMetaSection: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
    marginBottom: '40px',
  },
  publicMetaItem: {
    display: 'flex',
    gap: '12px',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '12px',
  },
  publicMetaLabel: {
    fontSize: '12px',
    color: '#999',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    marginBottom: '4px',
  },
  publicMetaValue: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#333',
  },
  publicSignatureSection: {
    textAlign: 'center',
    marginBottom: '40px',
    paddingBottom: '40px',
    borderBottom: '2px solid #f0f0f0',
  },
  publicSignature: {
    display: 'inline-block',
    borderTop: '2px solid #333',
    paddingTop: '16px',
  },
  publicSignatureName: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#333',
    fontFamily: 'Georgia, serif',
    fontStyle: 'italic',
    marginBottom: '4px',
  },
  publicSignatureTitle: {
    fontSize: '14px',
    color: '#666',
  },
  publicVerificationSection: {
    textAlign: 'center',
  },
  publicVerificationBox: {
    backgroundColor: '#f0f7ff',
    padding: '24px',
    borderRadius: '12px',
    border: '2px solid #5B21B6',
  },
  publicVerificationLabel: {
    fontSize: '12px',
    color: '#666',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    marginBottom: '8px',
  },
  publicVerificationId: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#5B21B6',
    fontFamily: 'monospace',
    marginBottom: '8px',
  },

  publicFooter: {
    maxWidth: '900px',
    margin: '40px auto 0',
    textAlign: 'center',
  },
  publicFooterText: {
    fontSize: '14px',
    color: '#999',
    lineHeight: '1.6',
  },
  loadingSpinner: {
    textAlign: 'center',
    padding: '100px 20px',
  },
  spinner: {
    width: '60px',
    height: '60px',
    border: '4px solid #f0f0f0',
    borderTop: '4px solid #5B21B6',
    borderRadius: '50%',
    margin: '0 auto 20px',
    animation: 'spin 1s linear infinite',
  },
  errorState: {
    textAlign: 'center',
    padding: '100px 20px',
  },
  errorIcon: {
    fontSize: '80px',
    marginBottom: '20px',
  },
  errorTitle: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#333',
    marginBottom: '12px',
  },
  errorDescription: {
    fontSize: '16px',
    color: '#666',
    maxWidth: '500px',
    margin: '0 auto',
  },

 
};

// Add keyframe animation
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);


export default PublicCertificateView;